// removed by extract-text-webpack-plugin
module.exports = {"infoPartition":"_27oQ1MbMXp35dz_AklzwDu","nav":"_38d6WFoHMQmPjHUGNuyXnO","active":"_2I5ngMoa8BxFV1rXZz-9y0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Info/Info.scss
// module id = 1352
// module chunks = 1